<template>
  <div
    class="search-member"
    :class="{
      'show-all': disabledShowAll,
      'no-content': cList.length == 0,
      'is-comment': isComment
    }"
  >
    <div class="search-top">
      <!-- <el-input v-model="searchInput" placeholder="搜索成员" size="mini" suffix-icon="el-icon-search" /> -->
      <el-input class="top-search" prefix-icon="icon iconfont iconicon_search1" v-model="searchInput" size="mini" placeholder="输入要添加的成员" clearable></el-input>
    </div>
    <div class="search-content-top-iscomment" v-if="isComment">
      <p class="tit">项目成员</p>
      <p class="num" :class="{'active': isCheckbox}" @click="handleCheckbox">
        多选
        <span v-if="isCheckbox && chosArr.length">{{ chosArr.length }}</span>
      </p>
    </div>
    <div class="search-content">
      <div
        class="search-content-item"
        v-for="(item, i) in cList"
        :key="i"
        @click="changeCheckout(item)"
      >
        <div class="item-content">
          <el-checkbox
            v-if="isCheckbox"
            v-model="item.chos"
            @change="changeCheckout(item)"
          ></el-checkbox>
          <Myavatar width="28px" height="28px" style="margin-right: 10px;" :imgUrl="item.user_avatar" :userName="item.realname">{{item.realname}}</Myavatar>
        </div>
        <i
          class="icon iconfont iconicon_selected_more_task"
          v-if="(selectItems.uid === item.uid) && !isCheckbox"
        ></i>
      </div>
      <nothing v-if="cList.length == 0" :width="'88px'" :config="{ tip: '暂无此成员' }"></nothing>
      <!-- <div class="no-list" >该成员不在项目成员列表中</div> -->
    </div>
    <div class="all-footer" @click="showAllMember" v-if="!searchInput && !disabledShowAll && parentId && isHasPermission">
      <i class="icon iconfont iconicon_drop_down_arrow rota90"></i>
      显示本项目成员
    </div>

    <div class="search-member-footer" v-if="isCheckbox">
      <span class="btn text-red" @click="handleClearAll">清空</span>
      <wf-button type="primary" @click="handleSubmit">确认</wf-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
export default {
  name: "ExecutorList",
  props: ['projectId', 'memberList', 'visible', 'uid', 'parentId', 'isHasPermission', 'isComment'],
  data() {
    return {
      selectItems: [],
      searchInput: '',
      radio: true,
      dataset: [],
      disabledShowAll: false, // 是否显示本项目所有成员
      isCheckbox: false, // 是否进入多选状态
      chosArr: [], // 已选成员名单
    }
  },
  watch: {
    memberList: {
      handler: function () {
        this.dataset = this.memberList ? JSON.parse(JSON.stringify(this.memberList)) : []
        this.init()
      },
      deep: true,
      immediate: true
    },
    visible() {
      if (this.visible) {
        this.disabledShowAll = false
        this.init()
      }
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('layout/layout', ['userInfo', "isBoss"]),
    cList() {
      if (this.searchInput === '') {
        return this.dataset;
      }
      return this.dataset.filter(item => {
        return item.realname.indexOf(this.searchInput) != -1
      });
    },
    adminMemberList() {
      return this.dataset.filter(item => {
        return [1, 2].includes(item.type)
      }).map((item) => {
        return item && item.uid
      }) || []
    },
    currentUserIsAdmin() {
      return this.adminMemberList.includes(this.userInfo.uid)
    }
  },
  methods: {
    init() {
      this.selectItems = this.cList.find(res => res.uid === this.uid) || {}
    },
    changeCheckout(items) {
      // 评论区@人功能引用
      if (this.isComment) {
        const _index = this.chosArr.findIndex(item => item.uid === items.uid)
        if (~_index) {
          // 反选
          this.chosArr.splice(_index, 1)
        } else {
          this.chosArr.push(items)
        }
        if (!this.isCheckbox) {
          // 单选，直接提交
          this.handleSubmit()
        }

        items.chos = !items.chos
      }

      if(this.selectItems && this.selectItems.uid === items.uid) { // 反选
        this.$emit('changeCheckout', '')
        this.$emit('update:visible', false)
      } else {
        this.selectItems = items
        this.$emit('changeCheckout', items)
        this.$emit('update:visible', false)
      }
    },
    showAllMember() {
      this.disabledShowAll = true
      this.$emit('showAll')
    },
    // 进入多选状态
    handleCheckbox() {
      if (this.isCheckbox) return
      this.isCheckbox = true
    },
    // 多选清除
    handleClearAll() {
      this.chosArr = []
      for (let i = 0, len = this.cList.length; i < len; i++) {
        this.cList[i].chos = false
      }
    },
    // 多选确认
    handleSubmit() {
      this.$emit('handleChos', this.chosArr)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/mixin.scss";
.search-member {
  width: 100%;
  max-height: 580px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 24px 0 8px;
  box-sizing: border-box;
  &.show-all {
    // max-height: 728px;
  }
  &.no-content {
    min-height: 276px;
  }
  &.is-comment {
    &.no-content {
      min-height: 580px;
      .nothing-box {
        top: 154px;
      }
    }
  }
  .all-footer {
    display: flex;
    align-items: center;
    margin: 16px 0 0;
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 12px;
    @include fontColorOpacity(.6);
    cursor: pointer;
    height: 20px;
    line-height: 20px;
    text-align: center;
    i {
      font-size: 12px;
      color:#A6A6A6;
      margin-right: 8px;
    }
  }
  .clear-btn {
    padding: 2px 8px;
    margin-left: 5px;
    // background-color: #fff;
    // border-color: #fff;
    // color: initial;
    // &:hover {
    //   color: #509aff;
    // }
  }
  .search-top {
    padding: 0 24px 16px 24px;
    // border-bottom: 1px solid #f1f2f4;
  }
  .search-content-top-iscomment {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    @include fontColorOpacity(.6);
    .num {
      cursor: pointer;
      &:hover {
        color: #2682FF;
      }
      &:active {
        color: #2560B1;
      }
      span {
        margin-left: 8px;
      }
    }
  }
  .colleagues-list {
    padding: 5px;
    display: block;
    margin-left: 0;
  }
  .search-content {
    width: 100%;
    height: 0;
    padding: 0 24px;
    box-sizing: border-box;
    flex: 1;
    overflow: auto;
    overflow: overlay;
    position: relative;
  }
  .search-content-item {
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    padding: 0 16px 0 8px;
    &:hover {
      @include bgColorOpacity(.04);
      // ::v-deep {
      //   span {
      //     color: #2682ff !important;
      //   }
      // }
    }
    &:active {
      @include bgColorOpacity(.04)
    }
    .item-content {
      display: flex;
      .el-checkbox {
        padding: 0 15px 0 0;
      }
    }
    i {
      color: $color-active;
    }
  }
  .active {
    // @include bgColorOpacity(.04);
    // ::v-deep {
    //   span {
    //     color: #2682ff;
    //   }
    // }
  }

  .search-member-footer {
    width: 100%;
    height: 52px;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(32, 32, 32, .08);
    .btn {
      font-size: 14px;
      line-height: 60px;
      padding-left: 8px;
    }
    .wf-button {
      margin-top: 14px;
    }
  }
}
</style>
